import { subscribe } from './event-logger';
import { META_EVENT_TYPES } from './event-types';

const DEFAULT_META_PIXEL_ID = '27664480569874607';
const NEW_MEMORY_KEEPER_META_PIXEL_ID = '28230518236620324';

// Funnels not listed here fall back to DEFAULT_META_PIXEL_ID.
const META_PIXEL_ID_BY_VERSION = {
    v50: NEW_MEMORY_KEEPER_META_PIXEL_ID,
    v51: NEW_MEMORY_KEEPER_META_PIXEL_ID,
    v53: NEW_MEMORY_KEEPER_META_PIXEL_ID,
    v56: NEW_MEMORY_KEEPER_META_PIXEL_ID,
    v57: NEW_MEMORY_KEEPER_META_PIXEL_ID,
    v58: NEW_MEMORY_KEEPER_META_PIXEL_ID,
    v59: NEW_MEMORY_KEEPER_META_PIXEL_ID
};

const getMetaPixelId = version => {
    const baseVersion = version?.split('.')[0];

    return META_PIXEL_ID_BY_VERSION[baseVersion] || DEFAULT_META_PIXEL_ID;
};

let isInitialized = false;

function initMetaPixel(version) {
    if (isInitialized || window.fbq) {
        return;
    }

    isInitialized = true;

    /* eslint-disable */
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    window.fbq('init', getMetaPixelId(version));
    window.fbq('track', 'PageView');
}

const metaTracker = {
    track(event, eventId) {
        if (!window.fbq) {
            return;
        }

        window.fbq('track', event, {}, eventId ? { eventID: eventId } : undefined);
    }
};

subscribe((eventType, eventProperties) => {
    if (META_EVENT_TYPES.hasOwnProperty(eventType)) {
        metaTracker.track(META_EVENT_TYPES[eventType], eventProperties?.eventId);
    }
});

export {
    metaTracker,
    initMetaPixel,
    getMetaPixelId
};
